/**
 * Theme colors matching Flutter app design
 */
export const theme = {
  colors: {
    // Primary colors from Flutter App Constants
    greenButton: '#32827F', // Primary green
    yellowButton: '#F9AE3B', // Yellow accent
    greenAccent: '#BA3634', // Lighter green for accents
    background: '#F5F5F5', // Light gray background
    cardBackground: '#FFFFFF', // White for cards
    textPrimary: '#212121', // Dark text
    textSecondary: '#757575', // Gray text
    divider: '#E0E0E0', // Divider color
    placeholder: '#969696', // Placeholder text
    
    // Chat specific colors (WhatsApp style)
    messageSent: '#DCF8C6', // WhatsApp green for sent messages
    messageReceived: '#FFFFFF', // White for received messages
    messageText: '#000000', // Black text on messages
    messageTime: '#667781', // WhatsApp grey for timestamps
    messageRead: '#53BDEB', // WhatsApp blue for read ticks
    typingIndicator: '#00897B', // Teal for typing indicator
    
    // Role colors
    roleAdmin: '#00897B', // Teal
    roleOfficeAdmin: '#7B1FA2', // Purple
    roleDriver: '#EF6C00', // Orange
  },
  
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '20px',
    xxl: '24px',
  },
  
  borderRadius: {
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    full: '9999px',
  },
  
  shadows: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.05)',
    md: '0 2px 4px rgba(0, 0, 0, 0.08)',
    lg: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
};

export default theme;

